import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios'

import * as firebase from "firebase";
const DetectRTC = require("detectrtc");

localStorage.setItem('browser', DetectRTC.browser.name.toLowerCase())
localStorage.setItem('os', DetectRTC.osName.toLowerCase())
localStorage.setItem('mobile',DetectRTC.isMobileDevice)


const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log(error.response.status)
  if (error.response.status === 401) {
    store.dispatch('logout')
    router.push('/login')
  }
  return Promise.reject(error)
})

Vue.config.productionTip = false

// import { VueReCaptcha } from "vue-recaptcha-v3";
// Vue.use(VueReCaptcha, { siteKey: "6Ldhw-QUAAAAAAPACmz5b63A8mP5pD97M0WbfoKp" });
// const recaptcha = this.$recaptchaInstance
//this.$recaptcha.hideBadge()
const firebaseConfig = {
  apiKey: process.env.VUE_APP_apiKey,
  authDomain: process.env.VUE_APP_authDomain,
  databaseURL: process.env.VUE_APP_databaseURL,
  projectId: process.env.VUE_APP_projectId,
  storageBucket: process.env.VUE_APP_StorageBucket,
  messagingSenderId: process.env.VUE_APP_messagingSenderId,
  appId: process.env.VUE_APP_appId,
  measurementId: process.env.VUE_APP_measurementId
};
firebase.initializeApp(firebaseConfig);

console.log(firebase.analytics())

//firebase.analytics().logEvent('patient test')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
